import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import RelativeLink from "../common/RelativeLink";
import { connect } from "react-redux";

// Eigenlijk InfrastuctuurSwitcher
const SideNav = ({ items, routePrefix, hideAlgemeenButton }) => {
	return (<aside className={"c-reactsidenav"}>
		{items.map((item, i) => {
			return item.initialisatieOK ?
				<RelativeLink key={i} className="c-reactsidenav__item truncated" to={routePrefix + "/infrastructuur/" + item.id}>{item.display}</RelativeLink> :
				<div key={i} className="disabled c-reactsidenav__item truncated">{item.display}</div>;
		})}
		{hideAlgemeenButton ? null : <RelativeLink key={items.length + 1} className="c-reactsidenav__item truncated" to={routePrefix + "/algemeen"} isRootLink>Algemeen</RelativeLink>}
	</aside>);
};

SideNav.propTypes = {
	items: PropTypes.array,
	routePrefix: PropTypes.string,
	hideAlgemeenButton: PropTypes.bool
};

function mapStateToProps(state, ownProps) {
	return {
		items: state.infrastructuren,
		routePrefix: state.layout.sideNavPrefix,
		hideAlgemeenButton: state.layout.hideAlgemeenButton
	};
}

export default connect(mapStateToProps)(withRouter(SideNav));
